export const HTTP_STATUS = {
    unauthorized: 401,
};
